import * as React from 'react';
import { cn, listIconMap, itemListProps } from '@restworld/utils-common';

import { Heading } from '@restworld/ui-ds-base';

export const PrimaryList: React.FunctionComponent<IListProps> = ({ itemList, type }) => (
  <Wrapper key={type}>
    {itemList.map(({ subTitle, label, icon, info, shouldBeVisible, key }: itemListProps) => (
      <Item
        key={key}
        subTitle={subTitle}
        label={label}
        icon={icon}
        type={type}
        info={info}
        shouldBeVisible={shouldBeVisible}
      />
    ))}
  </Wrapper>
);
export default PrimaryList;
const Item = ({ icon, label, subTitle, type, info, shouldBeVisible = true }: itemProps) => (
  <ItemWrapper shouldBeVisible={shouldBeVisible}>
    {icon && <IconWrapper type={type}>{listIconMap[icon]}</IconWrapper>}
    <ItemListWrapper>
      <ItemTitle type={type}>{label}</ItemTitle>
      <ItemDynamicLabel type={type}>{subTitle}</ItemDynamicLabel>
      {info && (
        <Heading as="span" size={6} weight="normal" color="muted" key="sub-title-info">
          {info}
        </Heading>
      )}
    </ItemListWrapper>
  </ItemWrapper>
);
// --> parent > styled components
const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col gap-5', className)} {...props} />
);
// --> child > styled components
const ItemWrapper = ({ shouldBeVisible, className, ...props }: any) => (
  <div className={cn('flex flex-row items-center', !shouldBeVisible && 'hidden', className)} {...props} />
);
const IconWrapper = ({ type, className, ...props }: any) => (
  <div
    className={cn(
      'inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg',
      type === 'default' ? 'bg-primary-50 text-primary-800' : 'bg-primary-400 text-white',
      className
    )}
    {...props}
  />
);
const ItemListWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('ml-2 flex flex-col', className)} {...props} />
);
const ItemTitle = ({ type, className, ...props }: any) => (
  <span
    className={cn(
      'text-xs',
      type === 'default' ? 'text-gray-600 font-normal' : 'text-primary-200 font-medium',
      className
    )}
    {...props}
  />
);
const ItemDynamicLabel = ({ type, className, ...props }: any) => (
  <span
    className={cn('font-semibold text-base', type === 'landing-card' ? 'text-white' : 'text-gray-900', '}', className)}
    {...props}
  />
);
type listType = 'default' | 'landing-card';

// --> types
interface IListProps {
  itemList: itemListProps[];
  type: listType;
}
interface itemProps extends itemListProps {
  type: listType;
}
